/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UpdateInputs */

const en_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const fr_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

const de_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento`)
};

const ru_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлять`)
};

const es_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const zh_cn2_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ja_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデート`)
};

const hi_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अद्यतन`)
};

const pt_pt2_update = /** @type {(inputs: UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update = /** @type {((inputs?: UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update(inputs)
	if (locale === "de") return de_update(inputs)
	if (locale === "it") return it_update(inputs)
	if (locale === "ru") return ru_update(inputs)
	if (locale === "es") return es_update(inputs)
	if (locale === "zh-CN") return zh_cn2_update(inputs)
	if (locale === "ja") return ja_update(inputs)
	if (locale === "hi") return hi_update(inputs)
	if (locale === "pt-PT") return pt_pt2_update(inputs)
	return en_update(inputs)
});